import { render, staticRenderFns } from "./PostButton.vue?vue&type=template&id=7cf99bdc&scoped=true"
import script from "./PostButton.vue?vue&type=script&lang=js"
export * from "./PostButton.vue?vue&type=script&lang=js"
import style0 from "./PostButton.vue?vue&type=style&index=0&id=7cf99bdc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cf99bdc",
  null
  
)

export default component.exports